import state from "./moduleCrewSettingsLicenseState.js";
import mutations from "./moduleCrewSettingsLicenseMutations.js";
import actions from "./moduleCrewSettingsLicenseActions.js";
import getters from "./moduleCrewSettingsLicenseGetters.js";

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};

